import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-89801c36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_app_loader = _resolveComponent("app-loader")!
  const _component_multiple_selection_pop_up = _resolveComponent("multiple-selection-pop-up")!
  const _component_move_to_pop_up = _resolveComponent("move-to-pop-up")!
  const _component_app_question_pop_up = _resolveComponent("app-question-pop-up")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_header, { customTitle: "Select Files" }, {
      "top-left": _withCtx(() => [
        _createElementVNode("a", {
          href: "javascript:void(0);",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["prevent"])),
          class: "back-link"
        }, " Cancel ")
      ]),
      "top-right": _withCtx(() => [
        (_ctx.isMixedSelected)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "icon icon-dots",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showMultiSelection = true))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.bigLoader)
      ? (_openBlock(), _createBlock(_component_app_loader, {
          key: 0,
          message: _ctx.bigLoader
        }, null, 8, ["message"]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "#popup" }, [
      (_ctx.showMultiSelection)
        ? (_openBlock(), _createBlock(_component_multiple_selection_pop_up, {
            key: 0,
            onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showMultiSelection = false)),
            onDelete: _ctx.openQuestionPopUp,
            onMove: _ctx.openMoveToPopUp
          }, null, 8, ["onDelete", "onMove"]))
        : _createCommentVNode("", true),
      (_ctx.isMoveToPopUp)
        ? (_openBlock(), _createBlock(_component_move_to_pop_up, {
            key: 1,
            onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isMoveToPopUp = false)),
            onMove: _ctx.moveMixed,
            mixedItems: _ctx.selectedMixedIds,
            manualMove: ""
          }, null, 8, ["onMove", "mixedItems"]))
        : _createCommentVNode("", true)
    ])),
    (_ctx.isQuestionPopUp)
      ? (_openBlock(), _createBlock(_component_app_question_pop_up, {
          key: 1,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isQuestionPopUp = false)),
          onDelete: _ctx.deleteMixed
        }, null, 8, ["onDelete"]))
      : _createCommentVNode("", true)
  ]))
}